$('.basket-wholesale-order__item-header-arrow').on('click', function (e) {
    e.preventDefault();

    const $parent = $(this).closest('.basket-wholesale-order__item');

    $parent.find('.basket-wholesale-order__item-body-box').slideToggle();
    $parent.toggleClass('basket-wholesale-order__item_active');
});